export default "__VITE_ASSET__6f937ff5__"